import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { getAlimtalkAllTemplate } from "../../AdminApi/commFunc";
import LineBtn from "../../components/Button/LineBtn";
import DotStatus from "../../components/DefaultStyles/DotStatus";
import LineBox from "../../components/DefaultStyles/LineBox";
import Loader from "../../components/DefaultStyles/Loader";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import AlimTalkFailFilter from "../../components/pages/Message/AlimTalkFail/AlimTalkFailFilter";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { useApi } from "../../hooks/useApi";
import AlimTalkFailModal from "../../components/pages/Message/AlimTalkFail/AlimTalkFailModal";
import { toast } from "react-toastify";

interface IAlimtalkFail {
  date: string;
  messageid: string;
  status: string;
  sms_status?: string;
  kakao_status: string;
  template: number;
  uid: number;
}

export default function AlimTalkFail() {
  const navigate = useNavigate();

  const [failData, setFailData] = useState([]);
  const [filter, setFilter] = useState({
    date: dayjs().format("YYYY-MM-DD"),
    isSuccess: "",
  });
  const [alimtalkFailModal, setAlimTalkFailModal] = useState({
    modal: false,
    data: {
      uid: 0,
      template: 0,
      date: "",
      messageid: "",
      status: {
        status: "",
        kakao_status: "",
        sms_status: "",
      },
    },
  });

  const { response, loading } = useApi({
    method: "get",
    url:
      filter?.date !== ""
        ? `kakao/fail?date=${filter?.date}` +
          (filter?.isSuccess !== "" ? `&isSuccess=${filter?.isSuccess}` : ``)
        : undefined,
  });

  const tableHead = [
    "UID",
    "템플릿 코드",
    "템플릿 내용",
    "알림톡",
    "문자",
    "발송 일시",
    "조회",
  ];

  useEffect(() => {
    if (response?.status === 200) {
      setFailData(response?.data?.reverse());

      if (response?.data?.length === 0) {
        toast.error("해당 검색어 정보를 찾을 수 없습니다.");
      }
    }
  }, [response]);

  return (
    <>
      <PageTitle title="알림톡 발송 실패" />

      <AlimTalkFailFilter filter={filter} setFilter={setFilter} />

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={1085}>
          <>
            {failData?.map((d: IAlimtalkFail) => (
              <TableBody key={d?.messageid}>
                <TableBodyItem
                  clickable={true}
                  onClick={() => navigate(`/users/info/${d?.uid}`)}
                >
                  {d?.uid}
                </TableBodyItem>

                <TableBodyItem>{d?.template}</TableBodyItem>

                <TableBodyItem>
                  {getAlimtalkAllTemplate().find(
                    (a) => Number(a?.value) === d?.template
                  )?.label ?? "-"}
                </TableBodyItem>

                <TableBodyItem>
                  <DotStatus
                    text={
                      200 <= Number(d?.status?.split("_")[1]) &&
                      Number(d?.status?.split("_")[1]) < 205 &&
                      d?.kakao_status === "0000"
                        ? "성공"
                        : "실패"
                    }
                    color={
                      200 <= Number(d?.status?.split("_")[1]) &&
                      Number(d?.status?.split("_")[1]) < 205 &&
                      d?.kakao_status === "0000"
                        ? "#00c7c7"
                        : "#f42d16"
                    }
                    size="sm"
                  />
                </TableBodyItem>

                <TableBodyItem>
                  <DotStatus
                    text={
                      d?.sms_status === undefined
                        ? "발송중"
                        : d?.sms_status === "-100"
                        ? "성공"
                        : "실패"
                    }
                    color={
                      d?.sms_status === undefined
                        ? "#858c97"
                        : d?.sms_status === "-100"
                        ? "#00c7c7"
                        : "#f42d16"
                    }
                    size="sm"
                  />
                </TableBodyItem>

                <TableBodyItem>
                  {dayjs(d?.date).format("YYYY-MM-DD HH:mm")}
                </TableBodyItem>

                <TableBodyItem>
                  <LineBtn
                    btnText="조회"
                    btnClickEvent={() =>
                      setAlimTalkFailModal({
                        modal: true,
                        data: {
                          uid: d?.uid,
                          template: d?.template,
                          date: d?.date,
                          status: {
                            status: d?.status,
                            kakao_status: d?.kakao_status,
                            sms_status: d?.sms_status!,
                          },
                          messageid: d?.messageid,
                        },
                      })
                    }
                  />
                </TableBodyItem>
              </TableBody>
            ))}
          </>
        </Table>
      </LineBox>

      {loading && <Loader />}

      {alimtalkFailModal.modal && (
        <AlimTalkFailModal
          closeEvent={() =>
            setAlimTalkFailModal({
              ...alimtalkFailModal,
              modal: false,
            })
          }
          alimtalkFailModal={alimtalkFailModal}
        />
      )}
    </>
  );
}
